var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "message-box" }, [
    _c("div", { staticClass: "message-box-wrapper" }, [
      _c(
        "div",
        { staticClass: "images" },
        _vm._l(_vm.images, function (img, i) {
          return _c(
            "div",
            { key: i, staticClass: "img" },
            [
              _c(
                "w-link",
                {
                  staticClass: "remove-button",
                  on: {
                    click: function ($event) {
                      return _vm.removeFile(img)
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "times" } })],
                1
              ),
              _c("img", { attrs: { src: _vm.storedUrls[i], alt: img.name } }),
            ],
            1
          )
        }),
        0
      ),
      _c(
        "div",
        { staticClass: "files" },
        _vm._l(_vm.otherFiles, function (file, i) {
          return _c(
            "div",
            { key: i, staticClass: "file" },
            [
              _c(
                "span",
                { staticClass: "content" },
                [
                  _c("w-fa", { staticClass: "mr", attrs: { icon: "file" } }),
                  _vm._v(" " + _vm._s(file.name) + " "),
                ],
                1
              ),
              _c(
                "w-link",
                {
                  staticClass: "remove-button",
                  on: {
                    click: function ($event) {
                      return _vm.removeFile(file)
                    },
                  },
                },
                [_c("w-fa", { attrs: { icon: "times" } })],
                1
              ),
            ],
            1
          )
        }),
        0
      ),
      _c(
        "div",
        { staticClass: "message" },
        [
          !_vm.filesDisabled
            ? _c(
                "app-file-input",
                {
                  staticClass: "file-input mr",
                  on: {
                    input: function ($event) {
                      return _vm.onFileInput($event)
                    },
                  },
                },
                [
                  _c(
                    "w-button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct("tooltip.attachement"),
                          expression: "$ct('tooltip.attachement')",
                        },
                      ],
                      staticClass: "light",
                    },
                    [_c("w-fa", { attrs: { icon: "paperclip" } })],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c("w-textarea-autogrow", {
            staticClass: "mr text-input",
            style: { flexGrow: 1 },
            attrs: {
              "min-height": _vm.minInputHeight,
              "max-height": 200,
              placeholder: _vm.$ct("message-input-label"),
              value: _vm.value,
            },
            on: {
              focus: function ($event) {
                _vm.inputFocused = true
              },
              blur: function ($event) {
                _vm.inputFocused = false
              },
              input: function ($event) {
                return _vm.onMessageInput($event)
              },
            },
            nativeOn: {
              keyup: [
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  if (
                    $event.ctrlKey ||
                    $event.shiftKey ||
                    $event.altKey ||
                    $event.metaKey
                  )
                    return null
                  return _vm.onEnter($event)
                },
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  if (!$event.ctrlKey) return null
                  if ($event.shiftKey || $event.altKey || $event.metaKey)
                    return null
                  return _vm.onCtrlEnter($event)
                },
              ],
            },
          }),
          _c(
            "w-button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.$ct("tooltip.send"),
                  expression: "$ct('tooltip.send')",
                },
              ],
              staticClass: "send",
              class: { disabled: _vm.isSending },
              style: { height: "100%" },
              attrs: { disaled: _vm.isSending },
              on: {
                click: function ($event) {
                  return _vm.sendMessage()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.send")) + " ")]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }